angular.module("riepilogoEControllo.components", [])
    .component("riepilogoEControllo", {
        templateUrl: "ng/components/riepilogoEControllo/riepilogoEControllo.view.html",
        bindings: {
            model: '<',
            returnMonitor: '&',
            snapshot: '<'
        },
        controller: RiepilogoEControllo,
        controllerAs: 'riepilogoEControlloCtrl'
    })

function RiepilogoEControllo(
    FinancialModel,
    $transactionFactory,
    $location,
    $timeout,
    SelectedNotaPivaRagSocSedeLegale,
    $workflowService
) {
    var self = this;

    self.$onInit = function () {
        self.checkValidityContact = false;
        self.indexCliente = self.model.leasingData.preventivo.contatti.riferimenti
            .findIndex(function (element) {
                return element.id == 'CLIENTE'
            })
        console.log(self.model);
        if (!self.model.leasingData.preventivo.summaryChecks.length) {
            self.model.leasingData.preventivo.summaryChecks.push(SelectedNotaPivaRagSocSedeLegale.build({
                selected: false,
                nota: 'Utilizzatore'
            }))
            self.model.leasingData.preventivo.summaryChecks.push(SelectedNotaPivaRagSocSedeLegale.build({
                selected: false,
                nota: 'DatiFinanziari'
            }))
            self.model.leasingData.preventivo.summaryChecks.push(SelectedNotaPivaRagSocSedeLegale.build({
                selected: false,
                nota: 'FirmTitGar'
            }))
            self.model.leasingData.preventivo.summaryChecks.push(SelectedNotaPivaRagSocSedeLegale.build({
                selected: false,
                nota: 'FornitoriBeneCondizioni'
            }))
            self.model.leasingData.preventivo.summaryChecks.push(SelectedNotaPivaRagSocSedeLegale.build({
                selected: false,
                nota: 'AdeguataVerificaClientela'
            }))
            self.model.leasingData.preventivo.summaryChecks.push(SelectedNotaPivaRagSocSedeLegale.build({
                selected: false,
                nota: 'AutorizzazioniSDD'
            }))
            self.model.leasingData.preventivo.summaryChecks.push(SelectedNotaPivaRagSocSedeLegale.build({
                selected: false,
                nota: 'QuestionarioQCC'
            }))
            self.model.leasingData.preventivo.summaryChecks.push(SelectedNotaPivaRagSocSedeLegale.build({
                selected: false,
                nota: 'GaranzieAccessorie'
            }))
            self.model.leasingData.preventivo.summaryChecks.push(SelectedNotaPivaRagSocSedeLegale.build({
                selected: false,
                nota: 'Privacy'
            }))
        }

    }

    self.next = function () {
        self.loadingNextStep = true;
        $transactionFactory.set(self.model);
        $timeout(function () {
            if (self.snapshot) {
                self.returnMonitor();
                self.loadingNextStep = false;
            } else {
                var type = 'WF_DIGITAL';
                var onlyLocal = true;
                $workflowService
                    .suspendInstance(FinancialModel.build(self.model), type, onlyLocal, self.model.taskFiliale)
                    .then(function (success) {
                        if (success) {
                            $location.path('/digitalLeasing');
                            self.loadingNextStep = false;
                        }
                    })
                    .catch(function (err) {
                        console.log("suspend instance failed! Error cause was: " + err);
                    })




            }

        }, 2000)

    }

    self.checkValidityContactFn = function (value) {
        self.checkValidityContact = value;
    }

}